export default "__VITE_ASSET__BoxNCHIF__"